import { jsx as _jsx } from "react/jsx-runtime";
import styles from './states.module.css';
export function SkeletonSet({ surface, rows = 5 }) {
    if (surface === 'band') {
        return (_jsx("div", { className: styles.skeletonSet, "aria-hidden": "true", children: _jsx("div", { className: `${styles.shimmer} ${styles.band}` }) }));
    }
    if (surface === 'tiles') {
        return (_jsx("div", { className: styles.tileRow, "aria-hidden": "true", children: Array.from({ length: rows }).map((_, i) => (_jsx("div", { className: `${styles.shimmer} ${styles.tile}` }, i))) }));
    }
    // table + drawer both render stacked rows mirroring their content rhythm.
    return (_jsx("div", { className: styles.skeletonSet, "aria-hidden": "true", children: Array.from({ length: rows }).map((_, i) => (_jsx("div", { className: `${styles.shimmer} ${styles.row}` }, i))) }));
}
//# sourceMappingURL=SkeletonSet.js.map